<div nxRow>
    <div nxCol="12">
        <p>{{"home.welcome" | translate}}</p>
    </div>
</div>
